import 'script-loader!jquery/dist/jquery.min';
import 'script-loader!what-input/dist/what-input.min';
import 'script-loader!foundation-sites/dist/js/foundation.min';
import 'script-loader!magnific-popup/dist/jquery.magnific-popup.min';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlay, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Vue from 'vue';
import App from './App.vue';
import router from './router';

import VueLogger from 'vuejs-logger';

import VueGtag from 'vue-gtag';

const options = {
  isEnabled: true,
  logLevel: process.env.NODE_ENV === 'production' ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
};

Vue.use(VueLogger, options);

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID }
}, router);

library.add(faPlay);
library.add(faFileDownload);
Vue.component('FontAwesomeIcon', FontAwesomeIcon);

Vue.config.productionTip = false;

export const vm = new Vue({
  created () {
    AOS.init({
      offset: 220,
      delay: 50,
      duration: 600,
      easing: 'easeOutQuart'
    });
  },
  router: router,
  render: h => h(App)
}).$mount('#app');
